{
    const $wrapper = $('.connected-products__wrapper--koishopper');
     function koishopperScripts () {
        const $widthSelector = $wrapper.find('select#width');
        const $lengthSelector = $wrapper.find('select#length');
        const widthRaw = parseFloat($widthSelector.val());
        const width = parseFloat(widthRaw.toFixed(2));

        const searchParams = new URLSearchParams(window.location.search);
        const lengthParam = searchParams.get('length');
        let length = parseInt($($lengthSelector).val());
        let originalPriceRaw = $wrapper.find('.original-price').text();
        const includesCommaAndDot = originalPriceRaw.includes(",") && originalPriceRaw.includes(".");
        const includesComma = originalPriceRaw.includes(",");

        if (includesCommaAndDot) {
            originalPriceRaw = originalPriceRaw.replace('.', '');
            originalPriceRaw = originalPriceRaw.replace(',', '.');
        }
        if (includesComma) {
            originalPriceComparision = originalPriceRaw.split(',')[0];
            if (originalPriceComparision < 1000 ) {
                originalPriceRaw = originalPriceRaw.replace(',', '.');
            }
        }

        originalPrice = parseFloat(originalPriceRaw);
        originalPrice = originalPrice.toFixed(2);

        let unitPrice = parseFloat((originalPrice / width / length));
        unitPrice = unitPrice.toFixed(2);

        function koishopperCalculator (width, length) {
            let finalPrice = unitPrice * width * length;

            finalPrice = parseFloat((finalPrice).toFixed(2))

            return finalPrice;
        };

        const finalPrice = koishopperCalculator(width, length);
        $($widthSelector).on('change',($el) =>  redirectProduct($el));
        $($lengthSelector).on('change',($el) =>  addQuantity($el));

        function textArea (width, length, finalPrice) {
            const finalPriceFormatted = theme.Shopify.formatMoney(
                finalPrice * 100,
                theme.money_with_currency_format
            );
            const $textArea = $wrapper.find('.connected-products__info-text--koishopper');
            $textArea.find('.width').text(width);
            $textArea.find('.length').text(length);
            $textArea.find('.unit-price').text(unitPrice);
            $textArea.find('.final-price').text(finalPrice.toFixed(2));
            $('.price__wrapper--koishopper .price').text(finalPriceFormatted);
        };

        textArea(width, length, finalPrice);

        function redirectProduct ($el) {
            const $currEl = $el.target;
            const $selectedOption = $($currEl).find('option:selected');
            const searchParams = new URLSearchParams(window.location.search);
            const lengthParam = searchParams.get('length');
            let lenghtVal = '';
            
            if(typeof(lengthParam) == "string" ){
                lenghtVal = `?length=${lengthParam}`;
            }

            const handle = `${$selectedOption.data('handle')}`;
            $("html, body").animate({ scrollTop: 0 }, "slow", function(){
                window.location = handle + lenghtVal;
            });
        };

        function addQuantity ($el) {
            const $currEl = $el.target;
            const $selectedLenOption = $($currEl).find('option:selected');
            const $selectedWithOption = $widthSelector.find('option:selected');
            const currLen = $selectedLenOption.val();
            const currWidth = parseFloat(($selectedWithOption.val() * currLen).toFixed(2));
            const $quantityInput = $('.quantity-input-koishopper');
            $quantityInput.attr('value', currLen );
            const queryString = `?length=${currLen}`;
            const newUrl = window.location.pathname + queryString;
            window.history.pushState({ path: newUrl }, '', newUrl);
            const finalPrice = koishopperCalculator(width, currLen);
            textArea(currWidth, currLen, finalPrice);
        }

        if(typeof(lengthParam) == "string" ){
            let inherited_length = parseInt(lengthParam);
            $lengthSelector.val(`${inherited_length}`);
            const finalPrice = koishopperCalculator(width, inherited_length);
            textArea(width, inherited_length, finalPrice);
            const $quantityInput = $('.quantity-input-koishopper');
            $quantityInput.attr('value', inherited_length );
        }
    }
    
    if ($wrapper.length > 0) koishopperScripts(); 
}